import { CategoryPageTemplate } from './CategoryPageTemplate'

export function LaserPage() {
  return <CategoryPageTemplate categoryKey="laser" namespace="laser" />
}
